define('customersDetailBodyMailsController',[
  'module',
  'logger',
  'underscore',
  'backbone',
  'app',
  'jquery',
  'customersDetailBodyMailsView',
  'entities/mails'
], function(
  Module,
  Logger,
  _,
  Backbone,
  App,
  $,
  MailsView
) {
  'use strict';

  Module.exports =  {

    showTab: function(data, region) {
      this.region = region;

        this.getMails(data);
    },

    getMails: function(data) {
        this.view = new MailsView({
            collection: null,
            customer: data.model
        });
        this.region.show(this.view);

    }
  };
});
